class FeaturedVideos extends HTMLElement {
  constructor() {
    super()
    this.videoElements = this.querySelectorAll('video-component')
    this.bindEvents()
  }

  bindEvents() {
    this.videoElements.forEach((video) =>
      video.querySelector('button.play-toggle').addEventListener('click', this.togglePlay.bind(this))
    )
  }

  togglePlay(e) {
    e.preventDefault()
    let currentVid = e.currentTarget.parentElement
    let videos = this.videoElements

    videos.forEach((video) => {
      if (video == currentVid) {
        if (video.classList.contains('active')) {
          video.classList.remove('active')
          video.querySelector('video').pause()
        } else {
          video.classList.add('active')
          video.querySelector('video').play()
        }
      } else {
        video.classList.remove('active')
        video.querySelector('video').pause()
      }
    })
  }
}

customElements.define('featured-videos', FeaturedVideos)
